

angular.module('admin')
.directive('fieldValue', function(FieldTplDir) {
	return {
		template: '<span ng-if="object.__perms[field.viewperm]" ng-include="\''+FieldTplDir+'field-view-\'+(field.client.widget.toLowerCase()||field.type.toLowerCase())+\'.html\'"></span>' + 
		          '<span ng-if="!object.__perms[field.viewperm]"><i class="fa fa-eye-slash"></i></span>',
		restrict: 'EA',
		/*scope: {
			aliases: '=*fieldValue',  // https://docs.angularjs.org/api/ng/service/$compile - =* shallow watch	
		},*/
		scope: {
    		compact: '=*compact',
    		object: '=*object',
    		field: '=*fieldValue'
    	},
		priority: 1,
		link: function(scope, element, attrs){
			scope.fieldTplDir = FieldTplDir;
		}
	}
	/**/ 
})
.directive('fieldEditor', function(FieldTplDir) {
	return {
		template: '<span ng-include="\''+FieldTplDir+'field-edit-\'+field.type.toLowerCase()+\'.html\'"></span>',
		restrict: 'A',
		scope: {
			aliases: '=*fieldEditor',  // https://docs.angularjs.org/api/ng/service/$compile - =* shallow watch	
		},
		priority: 1,
		link: function(scope, element, attrs){
			//console.log(scope.aliases);
			angular.extend(scope, scope.aliases);
		},
		controller: function($scope) {
			$scope.$watchCollection($scope.aliases, function(locals) {
				angular.extend($scope, $scope.aliases);
			});
		}
	}
})


